import { render, staticRenderFns } from "./FormInstrutorEdicao.vue?vue&type=template&id=5ab52604"
import script from "./FormInstrutorEdicao.vue?vue&type=script&lang=js"
export * from "./FormInstrutorEdicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports